{
  "memberGroupProfile.removeFromGroup.error": "尝试从组中移除会员时出错。",
  "memberGroupProfile.updateGroupPoints.error": "更新组积分时出错。",
  "memberGroupProfile.updateGroupTier.error": "更新组层级时出错。",
  "memberGroupProfile.removeFromGroup.deleteDialog.title": "是否确定要从组中移除此会员 <br />？",
  "memberGroupProfile.sperator.members": "会员",
  "memberGroupProfile.sperator.activity": "活动",
  "memberGroupProfile.title": "组参数文件",
  "memberGroupProfile.headerTitle": "组标识：{groupId}",
  "memberGroupProfile.updateTierBtn.label": "更新层级",
  "memberGroupProfile.addNewMembersBtn.label": "添加会员",
  "memberGroupProfile.notification": "查看会员参数文件的所有更新最多可能需要 24 小时。",
  "memberProfile.updateMembeerPoints.error": "更新会员积分时出错。请重试。",
  "memberProfile.updateMemberTier.error": "更新会员层级时出错。请重试。",
  "memberProfile.updateMemberPlan.error": "更新会员计划时出错。请重试。",
  "memberProfile.updateMemberAdditionalBenefits.error": "更新会员福利时出错。请重试。",
  "memberProfile.title": "会员参数文件",
  "memberProfile.headerTitle": "会员标识：{memberId}",
  "memberProfile.updateTierBtn.label": "更新层级",
  "memberProfile.updatePlanBtn.label": "迁移计划",
  "memberProfile.updatePlanBtn.tootip": "您无法迁移属于组的会员。",
  "memberProfile.updateBenefitsBtn.label": "更新福利",
  "memberProfile.notification": "查看会员参数文件的所有更新最多可能需要 24 小时。",
  "memberProfile.activity.title": "活动",
  "memberProfile.activity.downloadBtn.label": "下载优惠券报告",
  "memberProfile.activity.downloadBtn.tooltip": "以 CSV 格式下载会员优惠券报告。",
  "memberProfile.activity.pagination.pageSize": "显示 {input} 行",
  "memberProfile.activity.pagination.recordsDisplayed": "{start}-{end} 个，共 {total} 个",
  "memberProfile.duplicateAlert": "我们发现多个联系人具有此会员标识，因此我们无法显示个人数据。",
  "memberProfileOverview.groupProfileBtn.tooltip": "组参数文件",
  "memberProfileOverview.search.error": "搜索期间出错。请重试搜索。",
  "memberProfileOverview.search.noResults.lead": "没有符合您搜索条件的结果。请使用不同的搜索条件重试搜索。",
  "memberProfileOverview.search.noItems.title": "没有符合您搜索条件的结果。",
  "memberProfileOverview.search.noResults.title": "没有符合您搜索条件的结果。",
  "memberProfileOverview.deleteMemberIcon.tooltip": "删除会员",
  "memberProfileOverview.deleteMemberDialog.headline": "删除会员",
  "memberProfileOverview.deleteMemberDialog.notification": "如果您删除此会员，忠诚度会员资格将被永久取消。您无法撤消此操作。会员数据已保存在系统中。",
  "memberProfileOverview.deleteMemberDialog.memberToBeDeleted": "要删除的会员",
  "memberProfileOverview.deleteMemberDialog.checkboxText": "从报告数据库中删除所有忠诚度数据。",
  "memberProfileOverview.deleteMemberDialog.deleteButton": "删除",
  "memberProfileOverview.deleteMember.error": "删除此会员时出现错误。 ",
  "memberProfileOverview.deleteGroupDialog.headline": "是否确定要删除此组？",
  "memberProfileOverview.deleteGroupDialog.content": "删除此组后，所有忠诚度数据将被永久删除。",
  "memberProfileOverview.deleteGroup.error": "删除此组时出现错误。",
  "memberProfileOverview.deleteGroup.success": "组已删除。",
  "memberProfileOverview.tableHeader.memberID": "会员标识",
  "memberProfileOverview.tableHeader.tier": "层级",
  "memberProfileOverview.tableHeader.pointsToSpend": "消费积分",
  "memberProfileOverview.tableHeader.joinDate": "加入日期",
  "memberProfileOverveiw.memberTable.delete.label": "删除会员",
  "memberProfileOverview.groupTableHeader.groupId": "组标识",
  "memberProfileOverview.groupTableHeader.tier": "层级",
  "memberProfileOverview.groupTableHeader.points": "状态积分",
  "memberProfileOverview.groupTableHeader.members": "组会员",
  "memberProfileOverview.groupTableHeader.created": "创建日期",
  "memberProfileOverveiw.groupTable.delete.label": "删除组",
  "memberProfileOverveiw.grid.search.tooltip.groupEnabled": "搜索成员和群组（按标识）",
  "memberProfileOverveiw.grid.search.tooltip": "搜索成员（按外部标识）",
  "memberProfileOverveiw.grid.search.label": "搜索",
  "memberProfileOverveiw.grid.btnCreateNewMember.label": "创建会员",
  "memberProfileOverveiw.grid.btnCreateNewGroup.label": "创建会员组",
  "memberProfileOverveiw.grid.support.title": "忠诚度支持",
  "memberProfileOverveiw.grid.title": "会员资料",
  "activityType.online_purchase.name": "购买",
  "activityType.redemption.name": "忠诚度优惠",
  "activityType.exclusive_redemption.name": "积分访问",
  "activityType.customer_support.tierUpgrade.name": "层级升级",
  "activityType.customer_support.tierDowngrade.name": "降级层级",
  "activityType.customer_support.cashbackAdded.name": "已添加现金返还",
  "activityType.customer_support.pointsAdded.name": "已添加 {{points_name}}",
  "activityType.customer_support.planChange.name": "迁移到 {planName}/{planId}",
  "activityType.points_expiration.status.name": "状态 {{points_name}} 已过期",
  "activityType.points_expiration.cachback.name": "现金返还已过期",
  "activityType.tier_calculation.name": "已计算层级",
  "activityType.group_create.name": "已创建组",
  "activityType.group_calculation.name": "已计算组 ",
  "activityType.group_calculation.joinMember.name": "会员已加入组",
  "activityType.group_calculation.leftMember.name": "会员已退出组",
  "activityType.group_calculation.noChange.name": "组活动",
  "activityType.group_delete.name": "组已关闭",
  "activityType.additional_benefits.added.name": "已添加附加福利",
  "activityType.additional_benefits.removed.name": "已移除附加福利",
  "activityType.member_joined.name": "已加入忠诚度",
  "activityType.points_migrated.name": "已迁移",
  "groupActivity": "组活动",
  "activityElementType.purchase_points.negative": "已移除退货积分",
  "activityElementType.purchase_points.positive.fromCatalog": "已从目录购买",
  "activityElementType.purchase_points.positive.fromOnline": "购买",
  "activityElementType.byCustomerSupport": "客户支持",
  "activityElementType.tierChange": "层级更改",
  "activityElementType.redemption_points": "已兑换积分",
  "activityElementType.redemption_points.voucherRedemptionPoints": "积分优惠券",
  "activityElementType.redemption_points.exclusiveRedemptionPoints": "积分访问",
  "activityElementType.redemption_points.voucherRedemptionCashback": "优惠券现金返还",
  "activityElementType.redemption_free": "免费兑换",
  "activityElementType.redemption_free.voucher": "免费优惠券",
  "activityElementType.redemption_free.exclusive": "免费访问",
  "activityElementType.support_plan_change": "已迁移计划",
  "activityElementType.plan_change_points": "已迁移积分",
  "activityElementType.plan_change_voucher": "已迁移奖励",
  "activityElementType.contact_state.joinedGroup": "会员已加入组",
  "activityElementType.contact_state.leftGroup.allGroupActivity": "会员已退出组",
  "activityElementType.contact_state.leftGroup.onlyMemberLeft": "已分配共享积分",
  "rewardName.cashback": "现金返还",
  "rewardName.tier": "层级",
  "rewardName.pointsAdditional": "附加 {{points_name}}",
  "rewardName.pointsBasic": "基本 {{points_name}}",
  "rewardName.pointsExtra": "附加 {{points_name}}",
  "rewardName.pointsBonus": "奖金 {{points_name}}",
  "rewardName.statusUpgrade": "已升级状态",
  "rewardName.voucher": "优惠券",
  "rewardName.exclusiveAccess": "专属访问",
  "error.externalIdError.required": "输入外部标识",
  "error.externalIdError.exists": "此联系人已经是忠诚度会员。",
  "error.failToCreateMember": "创建此会员时出现错误。",
  "error.groupNameAlreadyExist": "此名称已存在。输入唯一名称。",
  "error.groupNameAlreadyExist.WithName": "此组名称 {groupName} 已存在。输入唯一名称。",
  "error.failedToCreateGroup": "创建此组时出现错误。",
  "error.failedToAddMembersToGroup": "向组添加会员时出错。",
  "createContactPopup.title": "创建会员",
  "createContactPopup.notification": "根据忠诚度管理设置中的会员设置，新会员将分配到相应层级。",
  "createContactPopup.multiPlanSelect.label": "选择计划",
  "createContactPopup.multiPlanSelect.tooltip": "选择新会员要加入的计划。",
  "createContactPopup.externalId.tooltip": "要添加新忠诚度会员，请输入您在销售数据中使用的相同外部标识。",
  "createContactPopup.externalId.label": "输入外部标识",
  "success.createGroup": "已创建组。",
  "success.addMembersToGroup": "已将会员添加到组。",
  "createGroupPopup.saveBtn.disabled.tooltip.create": "要创建组，您需要向组添加至少两名会员。",
  "createGroupPopup.saveBtn.disabled.tooltip.modify": "添加至少一个会员。",
  "createGroupPopup.saveBtn.disabled.tooltip.create.nameMissing": "输入组名称。",
  "createGroupPopup.title.create": "创建会员组",
  "createGroupPopup.title.modify": "添加会员",
  "createGroupPopup.notification": "要创建组，您需要向组添加至少两名会员。如果会员已经属于组，则该会员不会显示在搜索结果中。",
  "createGroupPopup.selectPlan.label": "选择计划",
  "createGroupPopup.selectPlan.tooltip": "您不能将不同计划的会员添加到同一个组。",
  "createGroupPopup.groupName.tooltip": "为组标识符创建唯一的名称。创建组后，您不能更改或复制此名称。",
  "createGroupPopup.groupName.label": "组名称",
  "createGroupPopup.addMembers.label": "添加会员",
  "createGroupPopup.addMembers.tooltip": "搜索成员（按外部标识）并添加到组。",
  "groupMemebersTable.header.dateAdded": "已添加日期",
  "groupMemebersTable.header.lastActivityDate": "最后的活动",
  "groupMemebersTable.header.removeFromGroup": "从组中移除",
  "groupProfileActivity.header.activity": "活动",
  "groupProfileActivity.header.tierExpiration": "层级过期",
  "groupProfileActivity.header.reward": "奖励",
  "groupProfileActivity.header.value": "值",
  "groupProfileActivity.header.expiration": "过期",
  "groupProfileActivity.header.orderId": "订单标识",
  "groupProfileActivity.header.time": "时间",
  "groupProfileActivity.header.admin": "管理员",
  "groupProfileActivity.header.status": "状态",
  "groupProfileActivity.search.tooltip": "按日期、活动或状态搜索。",
  "groupProfileActivity.header.totalPoints": "总积分",
  "groupProfileActivity.header.totalLoyaltyCredit": "总忠诚度业绩",
  "groupProfileActivity.header.activityType": "活动类型",
  "memberProfileActivity.search.tooltip": "按日期、活动、订单标识或状态搜索。",
  "memberProfileAdditionalBenefitsPopup.title": "更新福利",
  "error.failToLoadData": "加载数据时出错。",
  "memberProfileAdditionalBenefitsPopup.notification": "您可以在会员资料或忠诚度 API 中管理其他福利。",
  "memberProfileAdditionalBenefitsPopup.selectedBenefitIds.label": "选择福利",
  "memberProfileAdditionalBenefitsPopup.selectedBenefitIds.tooltip": "选择要为该会员更新的福利。保存更新后，会员即可享受这些福利。如果会员已兑换福利且代码已公开，则该福利将保留在会员的钱包中。",
  "memberProfileAdditionalBenefitsPopup.reason.tooltip": "输入原因以进行内部跟踪。",
  "memberProfileAdditionalBenefitsPopup.reason.label": "原因",
  "memberProfileAdditionalBenefitsPopup.confirmCb.label": "我了解这些更新将影响会员的福利。",
  "memberProfileChangePlanPopup.title": "迁移计划 ",
  "memberProfileChangePlanPopup.selectedPlan.label": "选择计划",
  "memberProfileChangePlanPopup.selectRewards.label": "选择要迁移的奖励",
  "memberProfileChangePlanPopup.selectRewards.tooltip": "选择要迁移到新计划的奖励。如果您不选择奖励，会员将从没有任何积分和优惠券的最低层级开始新计划。",
  "memberProfileChangePlanPopup.selectRewards.statusPointsCb.tooltip": "根据新计划中的状态积分和层级设置，会员将被分配到某个层级。",
  "memberProfileChangePlanPopup.selectRewards.statusPointsCb.label": "状态 {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.balancePointsCb.label": "余额 {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.balancePointsCb.tooltip": "根据新计划中的设置，积分有效期将重置并重新启动。",
  "memberProfileChangePlanPopup.selectRewards.pendingPointsCb.label": "待处理 {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.pendingPointsCb.tooltip": "待处理的积分将自动获得批准并添加到状态和余额积分中。",
  "memberProfileChangePlanPopup.selectRewards.redeemedVouchersCb.tooltip": "已兑换优惠券是忠诚度钱包/API 中带有公开代码的优惠券。固定福利多用途优惠券不会被迁移，即使它们被兑换也是如此。",
  "memberProfileChangePlanPopup.selectRewards.redeemedVouchersCb.label": "已兑换优惠券",
  "memberProfileChangePlanPopup.migrationConfirmation.label": "确认迁移",
  "memberProfileChangePlanPopup.migrationConfirmationCb.label": "此会员迁移到新计划后，当前计划中的会员资格和活动将被取消。",
  "memberProfileDetails.tierDetails.plan": "计划标识符：{planId}",
  "memberProfileDetails.tierDetails.group": "组名称：{groupName}",
  "memberProfileDetails.tierDetails.joinedOn": "加入日期： ",
  "memberProfileDetails.tierDetails.createdOn": "创建日期：",
  "memberProfileDetails.tierDetails.groupMembers": "组成员：{groupMembersNum}",
  "memberProfileDetails.tierDetails.personalInfo.firstName": "名字：{firstName}",
  "memberProfileDetails.tierDetails.personalInfo.lastName": "姓氏：{lastName}",
  "memberProfileDetails.tierDetails.personalInfo.email": "电子邮件：{email}",
  "memberProfileDetails.tierDetails.tierEntryDate": "进入层级日期",
  "memberProfileDetails.tierDetails.nextTierRequirements": "下一层级要求",
  "memberProfileDetails.pointsHistory.currentBalance.title": "当前余额",
  "memberProfileDetails.pointsHistory.currentBalance.pointsToSpend": "要消费的 {{points_name}} ",
  "memberProfileDetails.pointsHistory.currentBalance.expiresSoon": "即将过期",
  "memberProfileDetails.pointsHistory.currentBalance.groupStatus": "组状态 {{points_name}}",
  "memberProfileDetails.pointsHistory.currentBalance.groupPending": "组待处理 {{points_name}}",
  "memberProfileUpdatePointsPopup.add.points.label": "添加 {{points_name}}",
  "memberProfileUpdatePointsPopup.remove.points.label": "移除 {{points_name}}",
  "memberProfileUpdatePointsPopup.remove.spend.label": "从余额中移除",
  "memberProfileUpdatePointsPopup.add.spend.label": "添加到余额",
  "memberProfileUpdatePointsPopup.title.spend": "更新余额",
  "memberProfileUpdatePointsPopup.title.points": "更新积分",
  "memberProfileUpdatePointsPopup.pointsType.spend": "余额类型",
  "memberProfileUpdatePointsPopup.pointsType.points": "积分类型",
  "memberProfileUpdatePointsPopup.reason.tooltip": "输入更新原因以进行内部跟踪。",
  "memberProfileUpdatePointsPopup.description.tooltip": "如果需要，您可以输入更新原因，以便会员可以在活动历史记录中看到它。",
  "memberProfileUpdateTierPopup.options.invitationOnly": "{tierName} [仅限邀请]",
  "memberProfileUpdateTierPopup.title": "更新层级",
  "memberProfileUpdateTierPopup.notification": "将会员分配到层级后，该会员有权享受固定层级福利，并在层级计算设置中定义的时间期间内保持其状态。",
  "memberProfileUpdateTierPopup.selectTier.placeholder": "-- 选择层级 --",
  "memberProfileUpdateTierPopup.reason.tooltip": "出于内部跟踪目的，请输入以下操作的原因：{text}",
  "memberProfileUpdateTierPopup.confirmCb.label": "我了解这些更新将影响 {text} 会员的忠诚度状态。",
  "tierDowngrade.points.options.status.name": "根据会员当前的积分将其降级到某个层级。",
  "tierDowngrade.points.options.tier.name": "将会员降级到特定层级。",
  "tierDowngrade.points.options.tier.tooltip": "状态积分将更新为此层级所需的最低值。",
  "tierDowngrade.spend.options.status.name": "根据会员当前的忠诚度业绩将其降级到某个层级。",
  "tierDowngrade.spend.options.tier.name": "将会员降级到特定层级。",
  "tierDowngrade.spend.options.tier.tooltip": "忠诚度业绩将更新为此层级所需的最低值。",
  "tierUpdate.options.tierUpgrade.name": "升级层级",
  "tierUpdate.options.tierDowngrade.name": "降级层级",
  "membersReportDownloadButton.tooltip": "会员状态报告是 CSV 文件，其中包含会员忠诚度状态信息。下载可能需要几分钟。",
  "membersReportDownloadButton.label": "下载会员状态报告",
  "updatePointsType.points.options.loyalty": "忠诚度 {{points_name}}（状态 {{points_name}} 和消费 {{points_name}}）",
  "updatePointsType.points.options.status": "仅状态 {{points_name}}",
  "updatePointsType.points.options.spend": "仅消费 {{points_name}}",
  "updatePointsType.spend.options.status": "仅状态 {{points_name}}",
  "updatePointsType.spend.options.cashback": "仅现金返还",
  "memberPointsUpdateValidator.confirmed.isTrue": "确保输入所有必填信息。",
  "memberPointsUpdateValidator.reason.presence": "输入原因以进行内部跟踪。",
  "memberPointsUpdateValidator.pointsValue.presence": "输入大于零的积分数量。",
  "memberPointsUpdateValidator.pointsValue.numericality.notInteger": "输入大于零的积分数量。",
  "memberPointsUpdateValidator.pointsValue.numericality.notGreaterThan": "输入大于零的积分。",
  "memberPointsUpdateValidator.pointsValue.numericality.notLessThan": "输入小于 100,000 的积分。",
  "memberPointsUpdateValidator.pointsValue.minPointsForRemove.messageLoyaltyPoints": "移除的积分数不能大于现有积分数。",
  "memberPointsUpdateValidator.pointsValue.minPointsForRemove.message": "移除的积分数不能大于现有积分数。",
  "memberPointsUpdateValidator.pointsValue.minSumForRemove.message": "移除的积分数不能大于会员当前拥有的积分数。",
  "memberPointsUpdateValidator.pointsValue.minSumForRemove.messageCashback": "移除的现金返还数不能大于现有现金返还值。",
  "memberTierUpdateValidator.tierDowngradeType": "选择降级类型。",
  "memberTierUpdateValidator.selectedTierId": "选择层级。",
  "memberGroupProfile.removeFromGroup.deleteDialog.content.status": "移除此会员后，累积的状态积分将从组状态中移除。",
  "memberGroupProfile.removeFromGroup.deleteDialog.content.loyality": "移除此会员后，累积的忠诚度业绩将从组状态中移除。",
  "memberGroupProfile.updatePointsBtn.label.points": "更新积分",
  "memberGroupProfile.updatePointsBtn.label.balance": "更新余额",
  "memberProfile.updatePointsBtn.label.points": "更新积分",
  "memberProfile.updatePointsBtn.label.balance": "更新余额",
  "memberGroupProfile.removeFromGroup.deleteDialog.content": "移除此会员后，累积的 {pointType} 将从组状态中移除。",
  "memberGroupProfile.updatePointsBtn.label": "更新 {isPoints,select,true {Points} other {Balance}}",
  "memberProfile.updatePointsBtn.label": "更新 {isPoints,select,true {Points} other {Balance}}",
  "activityType.customer_support.cashbackRemoved.name": "已移除现金返还 ",
  "activityType.customer_support.pointsRemoved.name": "已移除 {{points_name}}",
  "activityType.points_expiration.toSpend.name": "余额 {{points_name}} 已过期",
  "memberProfileUpdatePointsPopup.confirmed.label": "我了解这些更新将影响 {text} 会员的忠诚度状态。"
}
